import React from "react";
import btorageBooster from "../../../assets/img/btorageBooster.png";
import StoreShell from "./StoreShell";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  상점사 인증화면(로그인 / 회원가입 / 비밀번호찾기) 공통 껍데기
 * ════════════════════════════════════════════════════════════════════════════════
 *  여명 필드 위에 유리판 하나가 떠 있는 구성.
 *  판 위쪽에는 '해가 걸린 선'(광택선)이 지나가고, 로고는 그 빛을 받는 자리에 놓인다.
 * ════════════════════════════════════════════════════════════════════════════════
 */
function StoreAuthShell({theme, title, desc, children, onTerms, onPrivacy, maxWidth = 460}) {
    return (
        <StoreShell theme={theme}>
            <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-4 tw-py-12">
                <div className="tw-w-full" style={{maxWidth: `${maxWidth}px`}}>

                    {/* 로고 — 여명 위에 떠 있는 작은 빛 */}
                    <div className="st-rise st-rise-1 tw-mb-7 tw-text-center">
                        <div className="tw-relative tw-inline-flex tw-items-center tw-justify-center">
                            <span aria-hidden="true"
                                  className="tw-absolute tw-h-[86px] tw-w-[86px] tw-rounded-full tw-animate-breathe"
                                  style={{background: 'radial-gradient(circle, rgba(255,190,72,.45), transparent 66%)'}}/>
                            <img src={btorageBooster} alt="Btorage" className="st-logo st-logo-lg tw-relative"/>
                        </div>
                        <p className="st-eyebrow tw-mt-4">Btorage OpenAPI</p>
                    </div>

                    {/* 본문 유리판 */}
                    <div className="st-glass st-rise st-rise-2 tw-px-7 tw-py-8 sm:tw-px-9">
                        {title ? (
                            <header className="tw-mb-7 tw-text-center">
                                <h1 className="st-display tw-text-[23px] tw-text-[color:var(--st-text)]">{title}</h1>
                                {desc ? (
                                    /*
                                     * text-center 를 여기에 직접 준다.
                                     *  부모(header)에서 물려받는 값은 p 를 직접 겨냥하는 규칙이
                                     *  어디에든 하나라도 있으면 그쪽에 밀린다(상속은 언제나 약하다).
                                     *  실제로 PC 에서만 왼쪽으로 쏠려 보이던 자리라 못을 박아둔다.
                                     *
                                     * 폭도 카드에 맞춘다.
                                     *  340px 고정은 모바일(카드 안쪽 약 300px)에서는 꽉 차서 표가 안 났지만,
                                     *  PC(카드 안쪽 약 390px)에서는 좁은 기둥이 되어 균형이 깨졌다.
                                     */
                                    <p className="tw-mx-auto tw-mt-2.5 tw-w-full tw-text-center tw-text-[12.5px] tw-leading-[1.8] tw-text-[color:var(--st-text-faint)] tw-break-keep">
                                        {desc}
                                    </p>
                                ) : null}
                            </header>
                        ) : null}

                        {children}
                    </div>

                    {/* 약관 */}
                    <footer className="st-rise st-rise-3 tw-mt-6 tw-text-center">
                        <div className="tw-flex tw-items-center tw-justify-center tw-gap-3 tw-text-[12px]">
                            <button type="button" className="st-link" onClick={onTerms}>이용약관</button>
                            <span aria-hidden="true" className="tw-text-[color:var(--st-text-faint)] tw-opacity-50">·</span>
                            <button type="button" className="st-link" onClick={onPrivacy}>개인정보취급처리방침</button>
                        </div>
                        <p className="tw-mt-3 tw-text-[11px] tw-tracking-wide tw-text-[color:var(--st-text-faint)] tw-opacity-70">
                            ⓒ Btorage. All rights reserved.
                        </p>
                    </footer>
                </div>
            </div>
        </StoreShell>
    );
}

export default StoreAuthShell;
